import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import Countdown from 'react-countdown';
import { Triangle } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchPackagesDetail, fetchCurrentPlan } from '../../redux/slices/EnhanceDisputeSlice';
import moreBackground from '../enhance_dispute/more-is-better.svg';
import moment from 'moment';
import { fetchStartCurrent } from '../../redux/slices/DisputeCenterSlice';
import InfoPopover from '../../components/new/InfoPopover';
import CountdownTemplates from './CountdownTemplates';

const CountdownClock = ({ date, notyf, currentRound, currentStatus }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const packagesDetail = useSelector(state => state.enhanceDispute.packagesDetail);
  const getAllReportData = useSelector(state => state.reports.getAllReportData);
  const clientName = getAllReportData?.data?.client_name;
  const startCurrentScore = useSelector(state => state.disputeCenter.startCurrentScore);
  const sc_status = useSelector(state => state.disputeCenter.sc_status);

  const [destinations, setDestinations] = React.useState([]);

  React.useEffect(() => {
    dispatch(fetchStartCurrent());
    let obj = {
      clientId: 1,
      roundid: 1,
    };
    dispatch(fetchPackagesDetail());
    dispatch(fetchCurrentPlan());
  }, []);

  React.useEffect(() => {
    if (sc_status === 'succeeded') {
      const letters = startCurrentScore.data.dispute_letter.dispute_letter_listing.map(letter => letter.letter_print_type);
      setDestinations(Array.from(new Set(letters)));
    }
  }, [sc_status]);

  let titleCaseName = '';
  if (clientName) {
    titleCaseName = clientName
      .split(' ')[0]
      .toLowerCase()
      .replace(/^\w/, c => c.toUpperCase());
  }

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    return (
      <>
        <div className='d-flex align-items-center justify-content-between mb-3' style={{ height: '36px' }}>
          <h3>Overview</h3>
          <div className='py-1 px-3'></div>
        </div>
        <Card className='border-0 shadow rounded mb-4' style={{ minWidth: '600px', backgroundImage: `url(${moreBackground})`, backgroundRepeat: 'no-repeat' }}>
          <Card.Body className='mb-0 rounded-3 rounded-3 p-3'>
            <Row className='d-flex flex-row'>
              <Col xs={6} className='d-flex flex-column text-center'>
                <b>Starting Date</b>
                {getAllReportData?.data?.round_start_date && moment(getAllReportData?.data?.round_start_date).format('MM/DD/YYYY')}
              </Col>
              <Col xs={6} className='d-flex flex-column text-center'>
                <b>Completion Date</b>
                {getAllReportData?.data?.round_end_date && moment(getAllReportData?.data?.round_end_date).format('MM/DD/YYYY')}
              </Col>
            </Row>
            <Row>

              <CountdownTemplates notyf={notyf} status={completed ? "GENERATE_RESULTS" : "COUNTDOWN"} data={{days, hours, minutes, seconds}} />
              <Col xs={6}>
                <Card className='border-0 shadow rounded-3 d-flex flex-column mb-3 p-2 h-100 todo-list'>
                  <style>{`
                  .todo-list {background: url(${moreBackground}) !important, background-size: cover;}
                  `}</style>
                  <Card.Body className='px-4 py-3 bg-transparent'>
                    <h4 className='text-dark-blue fw-regular'>Dispute Summary</h4>
                    <h6>{packagesDetail.length > 0 && packagesDetail[0].total_negative} Negative items</h6>
                    <h6 className='text-dark-blue fw-regular'>
                      {destinations.length} Letter Destinations{' '}
                      <sup>
                        <InfoPopover
                          iconMargin={0}
                          headerContent={null}
                          bodyContent={
                            <div>
                              {
                                <>
                                  {destinations.map((destination, key) => (
                                    <div key={key}>{destination}</div>
                                  ))}
                                </>
                              }
                            </div>
                          }
                        />
                      </sup>
                    </h6>

                    <h6>{packagesDetail.length > 0 && packagesDetail[0].total_destination} Major Reporting Agencies</h6>
                    <h6>{packagesDetail.length > 0 && packagesDetail[0].total_letter} Total Letters</h6>
                  </Card.Body>
                </Card>
              </Col>
              <Col xs={6}>
                <Card className='border-0 shadow rounded-3 d-flex flex-column mb-3 p-2 bg-primary h-100'>
                  <Card.Body className='px-4 py-3'>
                    <h5 className='text-white text-center mb-0'>Todo List for {titleCaseName}</h5>
                    <hr className='mx-auto mt-1 mb-3 text-white w-100' />
                    <div className='d-flex flex-row align-items-center mb-2'>
                      <p className='text-white fw-semibold me-2 my-auto'>Calculate Score Potential</p>
                      <div className='bg-white border border-2 border-dark rounded-circle d-flex justify-content-center position-relative  d-flex flex-row' style={{ width: '20px', height: '20px', cursor: 'pointer', pointerEvents: 'all' }}>
                        <Triangle size='10' fill='currentColor' className='m-auto position-absolute d-flex' style={{ transform: 'rotate(210deg)', right: '4px', top: '4px', cursor: 'pointer' }} onClick={() => navigate('/credit-builder')} />
                      </div>
                    </div>
                    <div className='d-flex flex-row align-items-center mb-2'>
                      <p className='text-white fw-semibold me-2 mb-0'> Audit Your Credit</p>
                      <div className='bg-white border border-2 border-dark rounded-circle d-flex justify-content-center position-relative  d-flex flex-row' style={{ width: '20px', height: '20px' }}>
                        <Triangle size='10' fill='currentColor' className='m-auto position-absolute d-flex' style={{ transform: 'rotate(210deg)', right: '4px', top: '4px', cursor: 'pointer' }} onClick={() => navigate('/credit-audit')} />
                      </div>
                    </div>
                    <div className='d-flex flex-row align-items-center mb-2'>
                      <p className='text-white fw-semibold me-2 mb-0'> Monitor Your Disputes</p>
                      <div className='bg-white border border-2 border-dark rounded-circle d-flex justify-content-center position-relative  d-flex flex-row' style={{ width: '20px', height: '20px' }}>
                        <Triangle size='10' fill='currentColor' className='m-auto position-absolute d-flex' style={{ transform: 'rotate(210deg)', right: '4px', top: '4px', cursor: 'pointer' }} onClick={() => navigate('/dispute-center')} />
                      </div>
                    </div>
                    <div className='d-flex flex-row align-items-center mb-2'>
                      <p className='text-white fw-semibold me-2 mb-0'> Need Help?</p>
                      <div className='bg-white border border-2 border-dark rounded-circle d-flex justify-content-center position-relative  d-flex flex-row' style={{ width: '20px', height: '20px' }}>
                        <Triangle size='10' fill='currentColor' onClick={() => navigate('/help')} className='m-auto position-absolute d-flex' style={{ transform: 'rotate(210deg)', right: '4px', top: '4px', cursor: 'pointer' }} />
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </>
    );
  };

  if (date) {
    return <Countdown date={moment(date)} renderer={renderer} />;
  } else if (currentRound > 1 && currentStatus === 7) {
    return (
      <Row>
        <CountdownTemplates status={"NEW_ROUND"} notyf={notyf} />
      </Row>
    );
  } else {
    return <></>
  }

};

export default CountdownClock;
